import { NgRedux } from '@ptl/angular-redux-store';
import { LabelType, Options } from '@angular-slider/ngx-slider';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ReducerUtilityService, StateStructure } from '@ptl/state';
import { Subject } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { OnExchangeEligibilityStateStructure, ON_EXCHANGE_ELIGIBILITY_REDUCER_NAME } from '../../on-exchange-enrollment/reducers/eligibility.reducer';
import { EligibilityManagerService } from '../../on-exchange-enrollment/services/eligibility-manager.service';

/** This slider allows the user to select a tax premium value if eligible ( typical federal poverty level associated ) */
@Component({
    selector: 'app-advance-premium-tax-credit-slider',
    templateUrl: './advance-premium-tax-credit-slider.component.html',
    styleUrls: ['./advance-premium-tax-credit-slider.component.scss'],
    standalone: false
})
export class AdvancePremiumTaxCreditSliderComponent implements OnInit {
  @Input() id?: string;
  @Input() options: Options;

  value: number;
  yearlyATPC: string;
  aptcEligible: boolean;
  aptcMonthly: string;
  aptcYearly: string;
  federalTaxReturnCredit: string;
  totalPremiumCredit: string;

  debounceSubject = new Subject<number>();
  debounceSubscription = this.debounceSubject.pipe(
    debounceTime(300)
  ).subscribe((value: number) => {
    const eligibilityState: OnExchangeEligibilityStateStructure
      = this.reducerUtilityService.getComponentStates()[ON_EXCHANGE_ELIGIBILITY_REDUCER_NAME];
    this.eligibilityManagerService.setSelectedMonthlyAptcForProspect(eligibilityState.currentProspectId, value);
  });

  constructor(
    private ngRedux: NgRedux<StateStructure>,
    private reducerUtilityService: ReducerUtilityService,
    private eligibilityManagerService: EligibilityManagerService
  ) { }

  async ngOnInit(): Promise<void> {
    const eligibilityState: OnExchangeEligibilityStateStructure
      = this.reducerUtilityService.getComponentStates()[ON_EXCHANGE_ELIGIBILITY_REDUCER_NAME];

    if (eligibilityState.currentProspectId) {
      const eligibilityData = await this.eligibilityManagerService.get(eligibilityState.currentProspectId);

      this.aptcEligible = eligibilityData.APTC;
      this.aptcMonthly = eligibilityData.APTCMonthly;
      this.aptcYearly = eligibilityData.APTCYearly;

      /** Value is either: (1) from state, (2) highest value possible */
      this.value
        = this.eligibilityManagerService.getSelectedMonthlyAptcForProspect(eligibilityState.currentProspectId)
          || 0;

      this.options = {
        floor: 0,
        ceil: Number(this.aptcMonthly),
        translate: (value: number, label: LabelType): string => {
          switch (label) {
            case LabelType.Low:
              return '<b>Selected APTC:</b> $' + value;
            case LabelType.High:
              return 'No value present lja9sugnsadg9uifgi';
            case LabelType.Floor:
              return 'MIN $' + value;
            case LabelType.Ceil:
              return 'MAX $' + value;
            default:
              return '$' + value;
          }
        }
      };

      this.processValues();
    }

  }

  valueChange(event: number) {
    this.value = event;
    this.debounceSubject.next(this.value);
  }

  processValues() {
    const yearlyAPTC = 12 * Number(this.value);

    this.yearlyATPC = yearlyAPTC.toFixed(2);
    this.federalTaxReturnCredit = (Number(this.aptcYearly) - yearlyAPTC).toFixed(2);
    this.totalPremiumCredit = this.aptcYearly;

    this.valueChange(Number(this.value.toFixed(2)));
  }

}
